import Service from '@ember/service';
import ToolData from '../data/tooldata';

export default class ToolDataService extends Service {
    data = ToolData;
}
